import { useTranslation } from 'react-i18next';
import { Button, Card, CardDescription, CardHeader, CardTitle } from '@monigo/ui';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ title, message, onRetry }: ErrorStateProps) {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title ?? t('errors.generic')}</CardTitle>
        {message ? <CardDescription>{message}</CardDescription> : null}
      </CardHeader>
      {onRetry ? (
        <Button variant="secondary" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      ) : null}
    </Card>
  );
}
